import { Trans, useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Button, Text } from 'components';
import { REFERRAL_COLORS } from './theme';

const Backdrop = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(10, 5, 22, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  z-index: 999;
`;

const Sheet = styled.div`
  position: relative;
  width: 100%;
  max-width: 480px;
  background-color: ${REFERRAL_COLORS.bg};
  border-radius: 24px;
  padding: 32px 24px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const IconRing = styled.div`
  width: 88px;
  height: 88px;
  border-radius: 44px;
  background-color: ${REFERRAL_COLORS.glow};
  border: 1px solid rgba(255, 193, 7, 0.4);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const CloseButton = styled.button`
  position: absolute;
  top: 16px;
  right: 16px;
  width: 32px;
  height: 32px;
  border-radius: 16px;
  background-color: ${REFERRAL_COLORS.secondaryCircle};
  border: none;
  cursor: pointer;
  color: ${REFERRAL_COLORS.white};
`;

/**
 * The referee's "you both earned" popup. `body` replaces the FanCam-worded sentence, for the Rate
 * It landing that reuses this modal.
 */
const ReferralAwardModal = ({ bonusPoints, momentsViewed, body, onContinue }) => {
  const { t } = useTranslation();

  return (
    <Backdrop>
      <Sheet>
        <CloseButton onClick={onContinue} aria-label="Close">
          ✕
        </CloseButton>
        <IconRing>
          <Text size="28px" marg="0 0 4px">
            🎁
          </Text>
          <Text b2 bold col={REFERRAL_COLORS.white}>
            {t('referral.awardBonusPts', { points: bonusPoints })}
          </Text>
        </IconRing>
        <Text h3 bold col={REFERRAL_COLORS.white} center marg="20px 0 8px">
          {t('referral.awardTitle')}
        </Text>
        <Text b1 col={REFERRAL_COLORS.white} center marg="0 0 24px">
          {body ?? (
            <Trans components={{ strong: <Text spanned b1 bold col={REFERRAL_COLORS.white} /> }}>
              {t('referral.awardBody', { count: momentsViewed, points: bonusPoints })}
            </Trans>
          )}
        </Text>
        <Button
          wid="100%"
          bg={REFERRAL_COLORS.cta}
          text={t('referral.awardContinue')}
          onClick={onContinue}
        />
      </Sheet>
    </Backdrop>
  );
};

export default ReferralAwardModal;
